export var config = {
  cssVarPrefix: 'ring',
  fontsPath: '/fonts'
};
//# sourceMappingURL=config.js.map